import { AxiosInstance } from "axios";
import { AuditLogEntryDto } from "../dto/AuditLogEntryDto";
import { ApiRouteHelpers } from "../../../root/apiRoutes";

export class AuditLogController {
  axios: AxiosInstance;
  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }

  async getAuditLogs(orgId: string): Promise<AuditLogEntryDto[]> {
    const url = ApiRouteHelpers.organization.documents.auditLog(orgId);
    const response = await this.axios.get(url);
    return response.data;
  }
}
